interface FooterProps {
  onShowLegal: () => void;
}

const footerItems = ['Guide', 'Comment ça marche', 'Tarifs'];
const footerHrefs = ['#deliverables', '#how-it-works', '#pricing'];

export default function Footer({ onShowLegal }: FooterProps) {
  return (
    <footer className="bg-bg-dark border-t border-white/10 py-12 px-6 md:px-16 lg:px-24">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8 md:gap-6 text-center md:text-left">
        <div className="flex items-center shrink-0">
          <img src="/assets/images/logo.png" alt="DreamerLife" className="h-14 md:h-20 w-auto" />
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          {footerItems.map((item, i) =>
            <a
              key={item}
              href={footerHrefs[i]}
              className="text-white/50 hover:text-white text-[11px] font-semibold uppercase tracking-widest transition-colors duration-200">
              {item}
            </a>
          )}
          <button
            onClick={onShowLegal}
            className="text-white/50 hover:text-white text-[11px] font-semibold uppercase tracking-widest transition-colors duration-200">
            Mentions Légales
          </button>
        </div>
        <p className="text-white/30 text-xs shrink-0">© 2026 DreamerLife</p>
      </div>
    </footer>
  );
}